import axiosInstance from './axiosConfig';
import axios from 'axios';


const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

interface Folder {
  id: string;
  name: string;
  description: string;
  createdAt: string;
}

interface CreateFolderData {
  name: string;
  description: string;
}

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const folderService = {
  // Get all folders
  getFolders: async (): Promise<Folder[]> => {
    try {
      const response = await axiosInstance.get<Folder[]>(`/folder`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching folders:', error);
      throw error;
    }
  },

  // Create a new folder
  createFolder: async (folderData: CreateFolderData): Promise<Folder> => {
    try {
      const response = await axiosInstance.post<Folder>(`/folder`, folderData, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error creating folder:', error);
      throw error;
    }
  },

  // Update a folder
  updateFolder: async (id: string, folderData: Partial<CreateFolderData>): Promise<Folder> => {
    try {
      const response = await axiosInstance.patch<any>(`/folder`, folderData, {
        params: { id }
      });
      console.log("updateFolder response", response);
      console.log("updateFolder response.data", response.data);
      console.log("updateFolder response.data.data", response.data.data);
      console.log("updateFolder response.data.folder", response.data.folder);
      
      // Try different possible response structures
      const updatedFolder = response.data.data || response.data.folder || response.data;
      console.log("Final updatedFolder", updatedFolder);
      
      return updatedFolder;
    } catch (error) {
      console.error('Error updating folder:', error);
      throw error;
    }
  },




  // Delete a folder
  deleteFolder: async (id: string): Promise<void> => {
    try {
      await axiosInstance.delete(`/folder`, {
        headers: getAuthHeaders(),
        params: { id }
      });
    } catch (error) {
      console.error('Error deleting folder:', error);
      throw error;
    }
  },

  moveFolder: async (folderId: string, customEnclosureId: string): Promise<void> => {
    try {
      await axiosInstance.put(
        `/folder/addToFolder`,
        { folderId, customEnclosureId },
        {
          headers: getAuthHeaders(),
        }
      );
    } catch (error) {
      console.error('Error Moving folder:', error);
      throw error;
    }
  },

  // Search folders
  searchFolders: async (query: string): Promise<Folder[]> => {
    try {
      const response = await axiosInstance.get<Folder[]>(`/folder/search?q=${encodeURIComponent(query)}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error searching folders:', error);
      throw error;
    }
  }
}; 